import _ from "lodash";
import i18n from "translations/i18n";
import { DELIVERY_OPTIONS } from "constants/DeliveryConstants";
import { VARIATION_PIECES, VARIATION_WEIGHT } from "constants/VariationConstant";
import { order_invoice } from "../urls";
import { findCategoryById, findMainCategoryBySubId } from "./categories";
import * as dayjs from "dayjs";

export const getPickListData = function (data, allProducts, categories) {
  let uniqueProducts = [];
  data.map((order) => {
    // Aggregate identical products WITHIN this order first, so per-order totals are merged
    const perOrderMap = {};

    const makeKey = (name, type, weight) => `${name}|${type || "_"}|${weight ?? "_"}`;

    const addToPerOrder = (entry) => {
      const key = makeKey(entry.name, entry.type, entry.weight);
      if (!perOrderMap[key]) {
        perOrderMap[key] = { ...entry, amountPerOrder: [] };
      } else {
        perOrderMap[key].quantity += entry.quantity;
      }
    };

    order.products.map((product) => {
      let currentProduct = _.find(allProducts, ["id", product.productId]);
      let productList = !!currentProduct && currentProduct.productItems ? currentProduct.productItems : null;

      const resolveCategory = (prod) => {
        let category;
        if (prod.categories) {
          let foundCategory = findCategoryById(categories, prod.categories[0]);
          if (!foundCategory) {
            category = "Verwijderde categorie";
          } else category = foundCategory.name;
          if (!!foundCategory && foundCategory.subcategoryId) {
            let mainCategory = findMainCategoryBySubId(categories, foundCategory.subcategoryId);
            category = mainCategory?.name || "Verwijderde categorie";
          }
        } else {
          if (typeof prod.category === "object") {
            category = prod.category[0];
          } else {
            let foundCategory = findCategoryById(categories, prod.category);
            if (!foundCategory) {
              category = "Verwijderde categorie";
            } else category = foundCategory?.name;
            if (category?.subcategoryId) {
              let foundMain = findMainCategoryBySubId(categories, category.subcategoryId);
              category = foundMain?.name || "Verwijderde categorie";
            }
          }
        }
        return category;
      };

      if (!!productList) {
        productList.map((item, index) => {
          let productById = _.find(allProducts, ["id", item.productId]);
          if (!product.giftCard) {
            const category = resolveCategory(productById);
            const quantity =
              item.type === VARIATION_PIECES
                ? product.quantity * item.value
                : item.type === VARIATION_WEIGHT
                  ? product.quantity * (item.quantity || 1)
                  : product.quantity;
            const weight = item.type === VARIATION_WEIGHT ? item.value : null;
            addToPerOrder({
              key: productById.id + index,
              name: productById.name,
              type: null,
              quantity,
              weight,
              amountPerOrder: [],
              category,
            });
          }
        });
      } else {
        if (!product.giftCard) {
          const category = resolveCategory(product);
          addToPerOrder({
            key: product.variantId,
            name: product.type ? product.name + " (" + product.type + ")" : product.name,
            type: product.type,
            quantity: product.quantity,
            weight: product.variation && product.variation.weight ? product.variation.weight : null,
            amountPerOrder: [],
            category,
          });
        }
      }
    });

    // Now merge this order's aggregated products into the global uniqueProducts,
    // pushing a SINGLE per-order total into amountPerOrder
    Object.values(perOrderMap).map((product) => {
      let uniqueProductIndex = _.findIndex(uniqueProducts, (o) => {
        if (product.type && product.weight)
          return o.type === product.type && o.weight === product.weight && o.name === product.name;
        else if (!product.type && product.weight) return o.weight === product.weight && o.name === product.name;
        else if (product.type && !product.weight) {
          return o.name === product.name;
        } else if (!product.type && !product.weight) return o.name === product.name;
      });
      if (uniqueProductIndex < 0) {
        uniqueProducts.push({
          ...product,
          amountPerOrder: [product.quantity],
        });
      } else {
        uniqueProducts[uniqueProductIndex].quantity += product.quantity;
        uniqueProducts[uniqueProductIndex].amountPerOrder.push(product.quantity);
      }
    });
  });

  return _.sortBy(uniqueProducts, (product) => product.category);
};

export const getSendListData = function (data) {
  let array = [];
  data.map((order) => {
    let customer = order.customer;
    let deliveryAddress = customer.address.delivery;
    let obj = {
      name: customer.firstName + " " + customer.lastName,
      street_and_number:
        deliveryAddress.street +
        " " +
        deliveryAddress.houseNumber +
        (!!deliveryAddress.addition ? deliveryAddress.addition : ""),
      zipcode_and_city: deliveryAddress.zipCode + " " + deliveryAddress.city,
      phone: customer.phoneNumber,
      deliveryType: order.delivery.type === DELIVERY_OPTIONS.SEND ? i18n.t("shipping") : i18n.t("pickup"),
      deliveryDate: order.delivery.date,
      orderId: order.orderId,
      orderNotes: order.orderNotes,
      dropPermission: order.delivery.dropPermission,
      pickupLocation: order.delivery.pickupLocation,
    };
    if (!order.containsOnlyGiftCards) array.push(obj);
  });
  return array;
};

/**
 * Get dates to disable for the datepicker
 * @param {*} current Current day in DatePicker
 * @param {*} deliveryType Delivery type selected by user
 * @returns
 */
export const getDisabledDatesForDatePicker = (current, deliveryType) => {
  let today = dayjs();
  let todayIndex = parseInt(dayjs(today).format("d"));
  let FRIDAY = 5;
  let SATURDAY = 6;
  let SUNDAY = 0;
  let MONDAY = 1;
  let excludeOffDays;

  if (deliveryType === DELIVERY_OPTIONS.SEND) {
    excludeOffDays =
      parseInt(dayjs(current).format("d")) === SATURDAY ||
      parseInt(dayjs(current).format("d")) === SUNDAY ||
      parseInt(dayjs(current).format("d")) === MONDAY;
  } else if (deliveryType === DELIVERY_OPTIONS.PICKUP) {
    excludeOffDays = parseInt(dayjs(current).format("d")) === SUNDAY || parseInt(dayjs(current).format("d")) === MONDAY;
  }

  if (todayIndex === FRIDAY) {
    if (deliveryType === DELIVERY_OPTIONS.SEND) {
      return dayjs(today).add(2, "days") >= current || excludeOffDays;
    } else if (deliveryType === DELIVERY_OPTIONS.PICKUP) {
      return dayjs(today).add(0, "days") >= current || excludeOffDays;
    }
  }

  if (todayIndex === SATURDAY) return dayjs(today).add(2, "days") >= current || excludeOffDays;
  else if (todayIndex === SUNDAY) return dayjs(today).add(1, "days") >= current || excludeOffDays;
  else return excludeOffDays;
};

/**
 * Generate invoice based on the order
 * @param order
 * @returns confirmation response
 */
export function generateInvoice(order) {
  return new Promise(function (resolve, reject) {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(order),
    };
    fetch(order_invoice, requestOptions)
      .then((invoice) => resolve(invoice))
      .catch((error) => reject(error));
  });
}
